export default __webpack_public_path__ + "static/media/empty-notification.0c114f32.png";